"use client";

import { RMarker } from "maplibre-react-components";
import React, { type ReactElement } from "react";
import { ThemeTypeEnum, type Site } from "@/types";
import { getThemePalette } from "@/utils";
import { getColors } from "@oreme/ui/lib/theme";

interface SitesSiteMarkerProps {
  site: Site;
}

function SitesSiteMarker({
  site,
}: Readonly<SitesSiteMarkerProps>): ReactElement {
  const color = getThemePalette(
    getColors(),
    site.theme as ThemeTypeEnum,
    500,
  ) as string;

  const latitude = Number(site.latitude);
  const longitude = Number(site.longitude);

  return (
    <RMarker
      initialColor={color}
      key={`site-marker-${site.id}`}
      latitude={latitude}
      longitude={longitude}
    />
  );
}

export { SitesSiteMarker, type SitesSiteMarkerProps };
